import {useState} from 'react'
import ProformaInvoiceForm from './ProformaInvoiceForm';
import ProformaInvoiceList from './ProformaInvoiceList';

const ProformaInvoice = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
  
  return (
    <>
      {fromIsShown ? (
          <ProformaInvoiceForm addForm={setFromIsShown} update={upData} />
        ) : (
          <ProformaInvoiceList addForm={setFromIsShown} update={setUpData} />
        )}
  
    </>
  )
}

export default ProformaInvoice